import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { styled } from '@linaria/react'
import { useNavigate } from '@tanstack/router'
import TagManager from 'react-gtm-module'
import { useTranslation } from 'react-i18next'

import { initialUserState } from '../../store/slices/userSlice'
import { useBoundStore } from '../../store/store'
import closeModal from '../../utils/closeModal'
import { clearUser } from '../../utils/user'
import Modal from './modal'

const Button = styled.button`
  width: 120px;
  text-align: center;
  font-size: 16px;
  padding: 7px 0;
  background-color: var(--primary-btn-bg);
  border: 1.5px solid var(--primary-btn-bg);
  color: var(--primary-btn-txt);
  border-radius: 22px;
  transition: all 0.2s ease-in-out;
  font-weight: 400;
  cursor: pointer;
  &.secondary {
    background-color: transparent;
    .theme-dark & {
      color: #fff;
      border: 1.5px solid #fff;
    }
    .theme-light & {
      color: #ccc;
      border: 1.5px solid #ccc;
    }
  }
  @media (min-width: 1200px) {
    font-size: 18px;
    width: 130px;
  }
`

const Text = styled.p`
  font-size: 16px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: 400;
  .theme-dark & {
    color: #e6e6e6;
  }
  .theme-light & {
    color: #888;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
  }
`

const LogoutModal = () => {
  const setUser = useBoundStore(state => state.user.setUser)
  const username = useBoundStore(state => state.user.username)
  const modal = useModal()
  const navigate = useNavigate()
  const { t } = useTranslation(['common', 'login'])

  const logOut = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'logout',
        event_category: 'logout',
        event_action: 'user_logout',
        event_label: 'Logout Success',
        user_id: username,
      },
    })
    setUser(initialUserState)
    clearUser()
    navigate({ to: '/' })
    location.reload()
  }

  return (
    <Modal id="log-out-modal">
      <Text>{t('sure-you-want-to-logout', { ns: 'login' })}</Text>
      <div className="flx-ctr" style={{ marginTop: '45px', gap: '15px' }}>
        <Button className="secondary" onClick={() => closeModal(modal)}>
          {t('cancel', { ns: 'common' })}
        </Button>
        <Button onClick={logOut}>{t('confirm', { ns: 'common' })}</Button>
      </div>
    </Modal>
  )
}

export default NiceModal.create(LogoutModal)
